import { logger } from '../../logger';
import { GA4IdsDiagnostics } from './getGa4Ids';

type LogGA4IdsDiagnosticsArgs = {
  checkoutFlow: 'standard' | 'affirm';
  cartId?: string | number;
} & GA4IdsDiagnostics;

/**
 * Logs the outcome of a single getGA4Ids() call at purchase time, so we can
 * later query Datadog for how often ids are missing and why (consent never
 * granted, script never loaded, ids not returned in time, etc.) without
 * relying on cross-referencing GA4/Segment exports after the fact.
 */
export const logGa4IdsDiagnostics = ({
  checkoutFlow,
  cartId,
  ...diagnostics
}: LogGA4IdsDiagnosticsArgs) => {
  logger.info(
    'GA4_IDS_CHECKED_AT_PURCHASE',
    `GA4 ids status: ${diagnostics.ga4_ids_missing_reason}`,
    {
      checkoutFlow,
      cartId,
      ...diagnostics
    }
  );
};
